import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import HomeTwo from "./pages/HomeTwo";
import Weddings from "./pages/Weddings";
import Events from "./pages/Events";
import Funerals from "./pages/Funerals";
import Contact from "./pages/Contact";
import Login from "./pages/admin/Login";
import ForgotPassword from "./pages/admin/ForgotPassword";
import ResetPassword from "./pages/admin/ResetPassword";
import Dashboard from "./pages/admin/Dashboard";
import BookingsList from "./pages/admin/BookingsList";
import BookingNew from "./pages/admin/BookingNew";
import BookingDetail from "./pages/admin/BookingDetail";
import CalendarPage from "./pages/admin/Calendar";
import PaymentsPage from "./pages/admin/Payments";
import SettingsPage from "./pages/admin/Settings";
import JournalIndex from "./pages/journal/JournalIndex";
import JournalArticle from "./pages/journal/JournalArticle";
import JournalList from "./pages/admin/JournalList";
import JournalEdit from "./pages/admin/JournalEdit";
import BookingPay from "./pages/BookingPay";
import BookingPayGroup from "./pages/BookingPayGroup";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import ScrollToTop from "./components/shared/ScrollToTop";
import { Toaster } from "@/components/ui/toaster";
import { AuthProvider } from "@/contexts/AuthContext";

const protect = (el: React.ReactNode) => <ProtectedRoute>{el}</ProtectedRoute>;

const App = () => {
  return (
    <AuthProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home-2" element={<HomeTwo />} />
        <Route path="/weddings" element={<Weddings />} />
        <Route path="/events" element={<Events />} />
        <Route path="/funerals" element={<Funerals />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/journal" element={<JournalIndex />} />
        <Route path="/journal/:slug" element={<JournalArticle />} />

        {/* Public client payment page — no login */}
        <Route path="/booking/pay/:token" element={<BookingPay />} />
        <Route path="/booking/pay-group/:token" element={<BookingPayGroup />} />

        <Route path="/admin" element={<Login />} />
        <Route path="/admin/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin/reset-password" element={<ResetPassword />} />

        <Route path="/admin/dashboard" element={protect(<Dashboard />)} />
        <Route path="/admin/bookings" element={protect(<BookingsList />)} />
        <Route path="/admin/bookings/new" element={protect(<BookingNew />)} />
        <Route path="/admin/bookings/:id" element={protect(<BookingDetail />)} />
        <Route path="/admin/calendar" element={protect(<CalendarPage />)} />
        <Route path="/admin/payments" element={protect(<PaymentsPage />)} />
        <Route path="/admin/journal" element={protect(<JournalList />)} />
        <Route path="/admin/journal/:id" element={protect(<JournalEdit />)} />
        <Route path="/admin/settings" element={protect(<SettingsPage />)} />

        <Route path="*" element={<Home />} />
      </Routes>
      <Toaster />
    </AuthProvider>
  );
};

export default App;
